export let initialState = {
  user: false
}

export const updateUser = (user) => (updatedUser) => {
  user.setState({ user: updatedUser })
}
